module.exports = __webpack_public_path__ + "static/media/rocket-image.svg";